import React, { useState } from 'react';
import Tooltip from 'components/Tooltip';
import Truncate from "react-truncate";

const TruncatedTextWithTooltip = ({ content, className, maxWidth = 200, placement = "top", onClick }) => {
  const [tooltip, setTooltip] = useState(false);

  const validatedMaxWidth = Number(maxWidth) || 0;

  const handleTooltip = (isTruncated) => {
    setTooltip(isTruncated)
  }

  return (
    <Tooltip placement={placement} disabled={!tooltip} content={content}>
      <span className={className} onWheel={() => {
        setTooltip(false);
      }}>
        <Truncate onClick={onClick} lines={1} width={validatedMaxWidth} ellipsis="..." onTruncate={handleTooltip}>
          {content}
        </Truncate>
      </span>
    </Tooltip>
  )
}

export default TruncatedTextWithTooltip;